const allTypes = [
  'ACTIVE_BANNER',
  'BAGGAGEREDEMPTION_DISCONNECT_ATTEMPTS',
  'BAGGAGEREDEMPTION_DISCONNECT_MODAL',
  'CHANGE_AIRPORTS_LIST_FILTERED',
  'CHANGE_AIRPORTS_LIST',
  'CHANGE_DESTINATION_AIRPORT',
  'CHANGE_ITINERARY',
  'CHANGE_ITINERARY',
  'CHANGE_ORIGIN_AIRPORT',
  'CHANGE_PASSENGER_COUNT',
  'CHANGE_SEAT_FARES',
  'CHANGE_TRIP_TYPE',
  'CONTROL_PANEL',
  'COUNT_ERROR_PAYMENT',
  'ELECTRONIC_VISA',
  'EMD_VALIDATE_VOUCHER',
  'EMD_VALIDATE_VOUCHER',
  'FFN_ASSOCIATION',
  'FFN_ASSOCIATION_MICRO',
  'FORM_ERROR',
  'FORM_OF_PAYMENTS',
  'GET_BALANCE_MICRO',
  'GET_CONTACTABILITY_TOKEN',
  'GET_ERROR_MESSAGE',
  'GET_ERROR_MESSAGE',
  'GET_GRANT_ACCESS',
  'GET_GRANT_ACCESS',
  'GET_OTP',
  'GET_SINGLE_BILLING',
  'GET_STAMPING_BILLING',
  'INFO_FOR_PURCHASE_METRIC',
  'LANGUAGE_BUNDLE_CACHE',
  'LANGUAGE_BUNDLE_CACHE',
  'LANGUAGE_BUNDLE',
  'LANGUAGE_BUNDLE',
  'MANAGE_CONFIRMATION_FROM_PAYMENT',
  'MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION',
  'MANAGE_RETRIEVE_PRIORITY_LIST',
  'PENDING_OPEN_MODAL_LOGIN',
  'PREVIEW_STATE_CHUBB',
  'PUT_TIME_API',
  'RECOVERY_USER_PASSWORD',
  'REFUND_INFO_TO_SALESFORCE',
  'REMOVE_CODE_ERROR',
  'DUAL_BUY_REDEEMED_BAGGAGES',
  'REMOVE_EMD_VOUCHER_VALUE',
  'REMOVE_EMD_VOUCHER_VALUE',
  'REMOVE_EMD_VOUCHER_WITHOUT_API',
  'REMOVE_EMD_VOUCHER_WITHOUT_API',
  'REMOVE_EMD_VOUCHER',
  'REMOVE_EMD_VOUCHER',
  'REMOVE_STATUS_CODE_ERROR',
  'RESET_SEATMAP_COLLECTION',
  'RETRIEVE_ALL_DESTINATION_INFO',
  'RETRIEVE_AMAIA_FAQ',
  'RETRIEVE_API_AIRPORTS',
  'RETRIEVE_BENEFITS_CORE',
  'RETRIEVE_CHECKIN_RESERVATION',
  'RETRIEVE_CHUBBPRICES',
  'RETRIEVE_CMS_AIRPORTS',
  'RETRIEVE_CMS_AIRPORTS_LITE',
  'RETRIEVE_CMS_ANCILARIES',
  'RETRIEVE_CMS_ANCILLARY_MYB',
  'RETRIEVE_CMS_ANCILLARY_MYB',
  'RETRIEVE_CMS_BRANDED_BENEFITS',
  'RETRIEVE_CMS_COBRANDCARD_AFFILIATE',
  'RETRIEVE_CMS_COUNTRIES',
  'RETRIEVE_CMS_MENU_PROMOTIONS',
  'RETRIEVE_CMS_MYB_MIGRATION_DOCS',
  'RETRIEVE_CMS_MYB_MIGRATION_DOCS',
  'RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND',
  'RETRIEVE_CMS_TRAVEL_INFORMATION',
  'RETRIEVE_CP_SESSION_TM',
  'RETRIEVE_FULFILL_REFUND',
  'RETRIEVE_INFO_SIGNUP_POPUP',
  'RETRIEVE_IROPS_ELEGIBILITY',
  'RETRIEVE_IROPS_ELEGIBILITY',
  'RETRIEVE_MEALSMENU',
  'RETRIEVE_MEALPRESELECT_FLIGHTS',
  'RETRIEVE_NONE_DESTINATION_INFO',
  'RETRIEVE_PNR',
  'RETRIEVE_QUOTE_REFUND',
  'RETRIEVE_REFUND_REASON',
  'RETRIEVE_SEATMAPS',
  'RETRIEVE_SHOPPING_CART',
  'RETRIEVE_TOUCHPOINTS_LOGIN',
  'RETRIVE_ALL_ANCILLARIES_PNR',
  'RETRIVE_USER_PROFILE',
  'SEAT_PRESELECT',
  'SEAT_PRESELECT',
  'SEAT_MAP_BANNER',
  'SEND_EMAIL_ITINERARY_REQUEST',
  'SEND_OTP',
  'SESSION_CHECKER',
  'SET_BILLING_DATA',
  'SET_CBX_MODAL',
  'SET_CORPORATE_SUPPLIER_SELECTED',
  'SET_DESTINATIONS',
  'SET_EMAIL_ITINERARY',
  'SET_EMD_VOUCHER',
  'SET_ERROR_REDIRECT',
  'SET_IS_CART_SESSION_MODAL_CLOSED',
  'SET_IS_CART_SESSION_MODAL_OPEN',
  'SET_LANGUAGE',
  'SET_REFUND_CODE_96_5',
  'SET_STATE_CHUBB',
  'SET_STATE_STORE_FRONT',
  'SET_STORE_FRONT',
  'SET_TOTAL_FLYGREEN',
  'SET_VALID_VOUCHER_VARS',
  'SET_VALID_VOUCHER_VARS',
  'STORE_FRONTS',
  'STORE_FRONTS',
  'SUBMIT_MEALS_SELECTED',
  'SUBMIT_PAYMENT',
  'TOAST_QUEUE',
  'TOAST_REMOVE',
  'TOKEN_INVALID_SECURITY',
  'TOUCH_POINT_PROPERTY_CP',
  'TRACK_WHEEL',
  'UPDATE_CART_SESSION_DATA',
  'UPDATE_CONSENT_CP',
  'UPDATE_DOCUMENT_NUMBERS',
  'UPDATE_G_DOCUMENT_NUMBERS',
  'UPDATE_SEATMAP_COLLECTION',
  'USER_ENROLLMENT',
  'USER_LOGIN',
  'USER_LOGOUT',
  'USER_PROFILE_LOGOUT',
  'USER_SIGNIN',
  'USER_SIGNUP',
  // Booking
  'CHANGE_AIRPORTS_LIST_FILTERED',
  'CHANGE_AIRPORTS_LIST',
  'CHANGE_DESTINATION_AIRPORT',
  'CHANGE_ORIGIN_AIRPORT',
  'CHANGE_PASSENGER_COUNT',
  'CHANGE_TRIP_TYPE',
  'CUBA_SELECTED',
  // Interaction Studio
  'ACTION_LOGIN',
  'ADD_TO_CART',
  'BOOKING_STEPFORM',
  'CHANGE_CORPORATE_COMPANY',
  'CHANGE_CORPORATE_FLOW',
  'CHANGE_SWITCH_FLOW',
  'CLOSE_MODAL_CORPORATE',
  'ENROLLMENT_ERROR',
  'LOGIN_ACTION',
  'LOGIN_CORPORATE',
  'LOGIN_VIEW',
  'OPEN_MODAL_LOGIN',
  'OPEN_MODAL_LOGIN_METHOD',
  'OPEN_MODAL_SIGNUP',
  'OPEN_MODAL_SIGNUP_METHOD',
  'OPEN_MODAL_CORPORATE',
  'PURCHASE',
  'QUICK_VIEW_ITEM',
  'RECOVER_ACCOUNT',
  'RECOVER_OTP_SETTINGS',
  'REGISTER_VIEW',
  'REGISTER',
  'REMOVE_FROM_CART',
  'RETRIEVE_CORPORATE_PROFILE_DATA',
  'RETRIEVE_CP_RESEND_OTP_LOGIN',
  'RETRIEVE_IP_ADDRESS',
  'RETRIEVE_UPGRADE_VOUCHER',
  'SEARCH_AMAIA',
  'SEARCH_AMAIA_CHUNK',
  'SEARCH_ITINERARY',
  'SESION_EXPIRE',
  'SET_ACCOUNT_PASSWORD_PIN',
  'SET_DATA_CORPORATE_RETRIEVE_PROFILE',
  'SET_DATA_CORPORATE',
  'SET_FLOW_CORPORATE',
  'SET_NAME_COMPANY',
  'SET_UPGRADE_VOUCHER',
  'STOP_VIEW_ITEM',
  'UPDATE_CART',
  'VALIDATE_EMAIL',
  'VALIDATE_TUTOR',
  'VIEW_CART',
];

/**
 * An async action type is not a string literal, as regular action types.
 * It's an object with START, SUCCESS and FAIL properties, each of it is a string literal
 * representing a typical redux action type.
 */
export function createAsyncActionType(name) {
  if (typeof name !== 'string') {
    console.warn(`Multiple async action middleware expected a string, instead recieved ${typeof name}`); // eslint-disable-line no-console
  }
  return {
    START: name,
    SUCCESS: name + '_SUCCESS',
    FAIL: name + '_FAIL',
  };
}

/**
 * Generated map has the shape
 * {
 *   code: {
 *    START: 'code_START',
 *    SUCCESS: 'code_SUCCESS',
 *    FAIL: 'code_FAIL'
 *   }
 * }
 */
const asyncActionTypes = {};
for (const code of allTypes) {
  asyncActionTypes[code] = createAsyncActionType(code);
}

export default asyncActionTypes;
